import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const FolderStructure = ({ folders, selectedFolder, onFolderSelect }) => {
  const [expandedFolders, setExpandedFolders] = useState(['cases', 'clients']);

  const toggleFolder = (folderId) => {
    setExpandedFolders(prev => 
      prev.includes(folderId) 
        ? prev.filter(id => id !== folderId)
        : [...prev, folderId]
    );
  };

  const FolderItem = ({ folder, level = 0 }) => {
    const hasChildren = folder.children && folder.children.length > 0;
    const isExpanded = expandedFolders.includes(folder.id);
    const isSelected = selectedFolder === folder.id;

    return (
      <div>
        <div
          className={`flex items-center px-4 py-2 cursor-pointer hover:bg-secondary-50 transition-smooth ${
            isSelected ? 'bg-primary-50 text-primary border-r-2 border-primary' : 'text-text-secondary'
          }`}
          style={{ paddingLeft: `${16 + level * 20}px` }}
          onClick={() => onFolderSelect(folder.id)}
        >
          {hasChildren && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleFolder(folder.id);
              }}
              className="mr-2 p-1 hover:bg-secondary-100 rounded transition-smooth"
            >
              <Icon 
                name={isExpanded ? 'ChevronDown' : 'ChevronRight'} 
                size={14} 
              />
            </button>
          )}
          
          <Icon 
            name={folder.icon || 'Folder'} 
            size={16} 
            className={`mr-3 ${isSelected ? 'text-primary' : 'text-text-secondary'}`}
          />
          
          <span className="flex-1 text-sm font-medium">{folder.name}</span>
          
          {folder.count > 0 && (
            <span className={`text-xs px-2 py-1 rounded-full ${
              isSelected ? 'bg-primary text-white' : 'bg-secondary-100 text-text-secondary'
            }`}>
              {folder.count}
            </span>
          )}
        </div>

        {hasChildren && isExpanded && (
          <div>
            {folder.children.map(child => (
              <FolderItem key={child.id} folder={child} level={level + 1} />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="h-full">
      <div className="p-4 border-b border-border">
        <h3 className="font-heading font-semibold text-text-primary">Document Library</h3>
      </div>
      
      <div className="py-2">
        {folders.map(folder => (
          <FolderItem key={folder.id} folder={folder} />
        ))}
      </div>
      
      <div className="p-4 border-t border-border mt-4">
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary">Storage Used</span>
            <span className="font-medium text-text-primary">2.4 GB</span>
          </div>
          <div className="w-full bg-secondary-200 rounded-full h-2">
            <div className="bg-primary h-2 rounded-full" style={{ width: '45%' }}></div>
          </div>
          <div className="text-xs text-text-secondary">4.6 GB remaining</div>
        </div>
      </div>
    </div>
  );
};

export default FolderStructure;